<template>
    <component
        :is="version"
        :fields="fields"
        :active-field="activeField"
        @change-field="setField"
        @clear-form="clearForm"
        v-model="form"
    ></component>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = [
    'is_collapsed',
    'user',
];

export default {
    name: 'CreateProject',
    data: () => ({
        fields: [
            {
                title: 'Общее описание',
                component: 'Common',
                model: 'common',
            },
            // {
            //     title: 'Паспорт проектной инициативы',
            //     component: 'Passport',
            //     model: 'passport',
            // },
            // {
            //     title: 'Этапы конкурса',
            //     component: 'Stages',
            //     model: 'stages',
            // },
            // {
            //     title: 'Целевые показатели',
            //     component: 'Targets',
            //     model: 'targets',
            // },
            // {
            //     title: 'Бюджет проекта',
            //     component: 'Budget',
            //     model: 'budget',
            // },
            // {
            //     title: 'Файлы',
            //     component: 'Files',
            //     model: 'files',
            // },
        ],

        activeField: 0,
        form: {},
    }),
    computed: {
        ...mapGetters(getters),
        version() {
            return this.is_collapsed
                ? 'WideCreateProject'
                : 'WideCreateProject';
        },
    },
    methods: {
        setField(index) {
            this.activeField = index;
        },
        clearForm() {
            this.form = {
                name: null,
                common: {
                    thematic_areas: [],
                    project_type: null,
                    target: null,
                    description: null,
                    actuality: null,
                },
                passport: {
                    start: null,
                    end: null,
                    realizeType: null,
                    targetAudience: null,
                    generalPartners: null,
                    informationPartners: null,
                    incentiveSystems: {
                        checked: [],
                        written: '',
                    },
                    engagement: {
                        checked: [],
                        written: '',
                    },
                },
                stages: {},
                targets: {},
                budget: {},
                files: {},
            };
        },
    },
    components: {
        MobileCreateProject: () =>
            import('../components/create-project/MobileCreateProject'),

        WideCreateProject: () =>
            import('../components/create-project/WideCreateProject'),
    },
    created() {
        if ( ! this.user.id)
            return window.location = process.env.VUE_APP_AUTH;

        this.clearForm();
    },
};
</script>

<style lang="scss" scoped>
</style>
